import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import SignalRF0 from '../../icons/SignalStrength/RFSignalStrength/SignalRF-0';
import SignalRF1 from '../../icons/SignalStrength/RFSignalStrength/SignalRF-1';
import SignalRF2 from '../../icons/SignalStrength/RFSignalStrength/SignalRF-2';
import SignalRF3 from '../../icons/SignalStrength/RFSignalStrength/SignalRF-3';
import { global } from '../../utils';
const RFConnectivityChip = ({ online, signalQuality, size = 16, }) => {
    if (online && signalQuality) {
        if (signalQuality >= -70) {
            return _jsx(SignalRF3, { size: size }, void 0);
        }
        else if (signalQuality >= -80) {
            return _jsx(SignalRF2, { size: size }, void 0);
        }
        else {
            return _jsx(SignalRF1, { size: size }, void 0);
        }
    }
    if (online && signalQuality === undefined) {
        return _jsx(_Fragment, { children: global.NOT_AVAILABLE }, void 0);
    }
    return _jsx(SignalRF0, { size: size * 1.2 }, void 0);
};
export default RFConnectivityChip;
